import React, { useEffect } from 'react';

/**
 * Ko-fi donation modal.
 * Triggered by "Support us" links in Footer and MobileMenu.
 * No floating button — just a modal that opens on demand.
 */
const KofiModal = ({ isOpen, onClose }) => {
  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="kofi-overlay" onClick={onClose}>
      <div className="kofi-panel" onClick={(e) => e.stopPropagation()}>
        <button className="kofi-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <iframe
          src="https://ko-fi.com/hasbaratracker/?hidefeed=true&widget=true&embed=true&preview=true"
          className="kofi-iframe"
          title="Support Hasbara Tracker on Ko-fi"
        />
      </div>
    </div>
  );
};

export default KofiModal;
